import { createBrowserHistory } from 'history'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { routerMiddleware, connectRouter } from 'connected-react-router'

import { reducer as analyticsReducer, REDUCER_NAME as ANALYTICS_REDUCER } from './analytics/state'
import { reducer as anamnesisReducer, REDUCER_NAME as ANAMNESIS_REDUCER } from './anamnesis/state'
import { reducer as appointmentReducer, REDUCER_NAME as APPOINTMENT_REDUCER } from './appointment/state'
import { reducer as customerReducer, REDUCER_NAME as CUSTOMER_REDUCER_NAME } from './customer/state'
import { reducer as emailReducer, REDUCER_NAME as EMAIL_REDUCER_NAME } from './email/state'
import { reducer as employeeReducer, REDUCER_NAME as EMPLOYEE_REDUCER } from './employee/state'
import { reducer as foilReducer, REDUCER_NAME as FOIL_REDUCER } from './foil/state'
import { reducer as globalsReducer, REDUCER_NAME as GLOBALS_REDUCER_NAME } from './globals/state'
import { reducer as gmailReducer, REDUCER_NAME as GMAIL_REDUCER_NAME } from './gmail/state'
import { reducer as invoiceReducer, REDUCER_NAME as INVOICE_REDUCE_NAME } from './invoice/state'
import { reducer as layoutReducer, REDUCER_NAME as LAYOUT_REDUCE_NAME } from './layout/state'
import { reducer as leadReducer, REDUCER_NAME as LEAD_REDUCER_NAME } from './lead/state'
import { reducer as logisticReducer, REDUCER_NAME as LOGISTIC_REDUCER_NAME } from './logistic/state'
import { reducer as paymentReducer, REDUCER_NAME as PAYMENT_REDUCER_NAME } from './payment/state'
import { reducer as partnerReducer, REDUCER_NAME as PARTNER_REDUCER_NAME } from './partner/state'
import { reducer as voucherReducer, REDUCER_NAME as VOUCHER_REDUCER_NAME } from './voucher/state'
import { reducer as processReducer, REDUCER_NAME as PROCESS_REDUCER_NAME } from './process/state'
import { reducer as prospectReducer, REDUCER_NAME as PROSPECT_REDUCER_NAME } from './prospect/state'
import { reducer as refinementReducer, REDUCER_NAME as REFINEMENT_REDUCER_NAME } from './refinement/state'
import { reducer as salesOrderReducer, REDUCER_NAME as SALES_ORDER_REDUCER_NAME } from './sales-order/state'
import { reducer as securityReducer, REDUCER_NAME as SECURITY_REDUCER_NAME } from './security/state'
import { reducer as storeReducer, REDUCER_NAME as STORE_REDUCER_NAME } from './store/state'
import { reducer as threeShapeReducer, REDUCER_NAME as THREE_SHAPE_REDUCER_NAME } from './threeshape/state'
import { reducer as treatmentReducer, REDUCER_NAME as TREATMENT_REDUCER_NAME } from './treatment/state'
import { reducer as feedbackReducer, REDUCER_NAME as FEEDBACK_REDUCER_NAME } from './feedback/state'
import { reducer as partialRefundReducer, REDUCER_NAME as PARTIAL_REFUND_REDUCER } from './partial-refund/state'
import { reducer as whatsappMessagesReducer, REDUCER_NAME as WHATSAPP_MESSAGES_REDUCER } from './whatsapp-messages/state'
import { reducer as worklistAttachmentReducer, REDUCER_NAME as WORKLIST_ATTACHMENT_REDUCER } from './worklist-attachment/state'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    [ANALYTICS_REDUCER]: analyticsReducer,
    [ANAMNESIS_REDUCER]: anamnesisReducer,
    [APPOINTMENT_REDUCER]: appointmentReducer,
    [CUSTOMER_REDUCER_NAME]: customerReducer,
    [EMAIL_REDUCER_NAME]: emailReducer,
    [EMPLOYEE_REDUCER]: employeeReducer,
    [FEEDBACK_REDUCER_NAME]: feedbackReducer,
    [FOIL_REDUCER]: foilReducer,
    [GLOBALS_REDUCER_NAME]: globalsReducer,
    [GMAIL_REDUCER_NAME]: gmailReducer,
    [INVOICE_REDUCE_NAME]: invoiceReducer,
    [LAYOUT_REDUCE_NAME]: layoutReducer,
    [LEAD_REDUCER_NAME]: leadReducer,
    [LOGISTIC_REDUCER_NAME]: logisticReducer,
    [PAYMENT_REDUCER_NAME]: paymentReducer,
    [PARTNER_REDUCER_NAME]: partnerReducer,
    [VOUCHER_REDUCER_NAME]: voucherReducer,
    [PROCESS_REDUCER_NAME]: processReducer,
    [PROSPECT_REDUCER_NAME]: prospectReducer,
    [REFINEMENT_REDUCER_NAME]: refinementReducer,
    [SALES_ORDER_REDUCER_NAME]: salesOrderReducer,
    [SECURITY_REDUCER_NAME]: securityReducer,
    [STORE_REDUCER_NAME]: storeReducer,
    [THREE_SHAPE_REDUCER_NAME]: threeShapeReducer,
    [TREATMENT_REDUCER_NAME]: treatmentReducer,
    [PARTIAL_REFUND_REDUCER]: partialRefundReducer,
    [WHATSAPP_MESSAGES_REDUCER]: whatsappMessagesReducer,
    [WORKLIST_ATTACHMENT_REDUCER]: worklistAttachmentReducer,
})

export const history = createBrowserHistory()

const store = createStore(
    createRootReducer(history),
    composeEnhancers(
        applyMiddleware(
            routerMiddleware(history),
            thunkMiddleware
        )
    )
)

export default store



// WEBPACK FOOTER //
// ./src/modules/store.js